import { Action, createFeature, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { FrequentlyAskedQuestion } from './frequently-asked-question.model';
import {FrequentlyAskedQuestionActions} from './frequently-asked-question.actions';

export const frequentlyAskedQuestionsFeatureKey = 'frequentlyAskedQuestions';

export interface State extends EntityState<FrequentlyAskedQuestion> {
 loading : boolean;
 error : any
}

export const adapter: EntityAdapter<FrequentlyAskedQuestion> = createEntityAdapter<FrequentlyAskedQuestion>({
  selectId : (faq) => faq.uniqueId
});

export const initialState: State = adapter.getInitialState({
     loading :false,
     error : null
});

export const reducer = createReducer(
  initialState,
  on(FrequentlyAskedQuestionActions.addFrequentlyAskedQuestion,
    (state, action) =>  {return  {...state , loading : true}}
  ),
  on(FrequentlyAskedQuestionActions.addFrequentlyAskedQuestionSuccess,
    (state, {frequentlyAskedQuestion}) => adapter.addOne(frequentlyAskedQuestion, {...state, loading : false})
  ),
  on(FrequentlyAskedQuestionActions.addFrequentlyAskedQuestionFailure,
    (state, { error}) => { return { ...state, loading : false , error }}
  ),

  on(FrequentlyAskedQuestionActions.loadFrequentlyAskedQuestions,
    (state, action) =>  {return  {...state , loading : true}}
  ),
  on(FrequentlyAskedQuestionActions.loadFrequentlyAskedQuestionsSuccess,
    (state, {frequentlyAskedQuestions}) => adapter.addMany(frequentlyAskedQuestions, {...state, loading : false})
  ),
  on(FrequentlyAskedQuestionActions.loadFrequentlyAskedQuestionsFailure,
    (state, { error}) => { return { ...state, loading : false , error }}
  ),

  on(FrequentlyAskedQuestionActions.updateFrequentlyAskedQuestions,
    (state, action) => { return { ...state, loading : true}}
  ),
  on(FrequentlyAskedQuestionActions.updateFrequentlyAskedQuestionSuccess,
    (state, {frequentlyAskedQuestion}) => adapter.updateOne(frequentlyAskedQuestion, { ...state,loading : false})
  ),
  on(FrequentlyAskedQuestionActions.updateFrequentlyAskedQuestionFailure,
    (state, { error}) => { return { ...state, loading : false, error}}
  ),

  on(FrequentlyAskedQuestionActions.deleteFrequentlyAskedQuestion,
    (state, action) => { return { ...state, loading : true}}
  ),
  on(FrequentlyAskedQuestionActions.deleteFrequentlyAskedQuestionSuccess,
    (state, {uniqueId}) => adapter.removeOne(uniqueId, { ...state,loading : false})
  ),
  on(FrequentlyAskedQuestionActions.deleteFrequentlyAskedQuestionFailure,
    (state, { error}) => { return { ...state, loading : false, error}}
  ),


  on(FrequentlyAskedQuestionActions.upsertFrequentlyAskedQuestion,
    (state, action) => adapter.upsertOne(action.frequentlyAskedQuestion, state)
  ),
  on(FrequentlyAskedQuestionActions.addFrequentlyAskedQuestions,
    (state, action) => adapter.addMany(action.frequentlyAskedQuestions, state)
  ),
  on(FrequentlyAskedQuestionActions.upsertFrequentlyAskedQuestions,
    (state, action) => adapter.upsertMany(action.frequentlyAskedQuestions, state)
  ),

  on(FrequentlyAskedQuestionActions.updateFrequentlyAskedQuestions,
    (state, action) => adapter.updateMany(action.frequentlyAskedQuestions, state)
  ),
  on(FrequentlyAskedQuestionActions.deleteFrequentlyAskedQuestions,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(FrequentlyAskedQuestionActions.clearFrequentlyAskedQuestions,
    state => adapter.removeAll(state)
  ),
);

export const FrequentlyAskedQuestionFeature = createFeature({
  name: frequentlyAskedQuestionsFeatureKey,
  reducer,
  extraSelectors: ({ selectFrequentlyAskedQuestionsState }) => ({
    ...adapter.getSelectors(selectFrequentlyAskedQuestionsState)
  }),
});



export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = FrequentlyAskedQuestionFeature;
